export const registrationLazyLoaded = {
  path: 'registration'
}

export const registrationSupportType = {
  path: 'support-type'
}

export const registrationFullName = {
  path: 'full-name'
}

export const registrationPostcode = {
  path: 'postcode'
}

export const registrationCentre = {
  path: 'centre'
}

export const registrationEmailMobile = {
  path: 'sign-in-method'
}

export const registrationPassword = {
  path: 'password'
}

export const registrationVerificationCode = {
  path: 'final-check'
}

export const registrationVerificationCodeContinued = {
  path: 'continue-verification'
}

export const registrationDemographicsAge = {
  path: 'getting-to-know-you/age'
}

export const registrationDemographicsEmployment = {
  path: 'getting-to-know-you/employment'
}

export const registrationDemographicsGender = {
  path: 'getting-to-know-you/gender'
}

export const registrationPrivacyTerms = {
  path: 'privacy-terms'
}

export const registrationMarketingContact = {
  path: 'contacting-you'
}

export const registrationCompleteState = {
  path: 'complete'
}

export const registrationContinuedCompleteState = {
  path: 'verification-complete'
}

export const registrationUnverified = {
  path: 'unverified'
}

export const registrationLearner = {
  path: 'learner'
}
export const registrationStaff = {
  path: 'staff'
}
export const registrationExistingStaff = {
  path: 'existing-staff'
}

export const registrationTitle = {
  title: 'Register | Learn My way'
}
